<template>
  <v-container>
    <div style="display:flex;">
      <h1>VERNERUNDE</h1>
      <v-spacer></v-spacer>
      <v-btn href="https://dikono.sharepoint.com/:b:/s/Personalogorganisasjon-Personal/IQBNTA9v7U0-SLkLoyQ9LRrXAQh7pygk_a0h0jQit1fFp8Y?e=pfE641" target="_blank">Organisasjonsplattform</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=126359&ok=tr4djpn6g0y1s83" target="_blank">Arbeidsreglement</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=117963&ok=tr4djpn6g0y1s83" target="_blank">Etiske retningslinjer</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=123520&ok=tr4djpn6g0y1s83" target="_blank">retningslinjer for trafikk</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=120118&ok=tr4djpn6g0y1s83#docContentList120118x1770207407ClAnchor4" target="_blank">Prosedyre Vold & Trusler</v-btn>
    </div>
    <v-tabs v-model="activeTab">
      <v-tab><a href="https://dikono.sharepoint.com/:w:/s/Personalogorganisasjon-Personal/IQB6gLfwLhS5RZD87fNG8-zWAdbRxNMOZcypZwdW_EdeIHM?e=cV97nf" target="_blank">Info</a></v-tab>
      <v-tab ripple>Vernerunden</v-tab>
      <v-tab ripple>Tiltaksvurdering</v-tab>
    <v-tab-item></v-tab-item>
      <!-- SKJEMA -->
      <div class="vernerunde-actions">
       <v-btn :disabled="!canStartNewVernerunde" color="blue lighten-2" text @click="newVernerunde">
         Ny Vernerunde
       </v-btn>
       <v-btn :disabled="!canGeneratePdf" color="blue lighten-2" text @click="generatePDF">
         Lag PDF
       </v-btn>
       <v-btn v-if="isViewingHistorical" color="blue lighten-2" text @click="loadCurrentResponses">
         Tilbake til nåværende
       </v-btn>
       <v-menu offset-y>
         <template v-slot:activator="{ on, attrs }">
           <v-btn
             color="blue lighten-2"
             text
             v-bind="attrs"
             :disabled="!previousVernerunder.length"
             v-on="on"
           >
             Tidligere vernerunder
           </v-btn>
         </template>
         <v-list dense>
           <v-list-tile
             v-for="vernerunde in previousVernerunder"
             :key="vernerunde.vernerunde_id"
             @click="loadHistoricalResponses(vernerunde)"
           >
             <v-list-tile-content>
               <v-list-tile-title>{{ formatVernerundeLabel(vernerunde) }}</v-list-tile-title>
             </v-list-tile-content>
           </v-list-tile>
         </v-list>
       </v-menu>
      </div>
    <v-tab-item>
      <div class="form-wrapper">
        <div v-if="loadingDialog">{{ loadingDialogText }}</div>
        <div v-else-if="!questions.length">Ingen spørsmål funnet.</div>
        <div v-if="!loadingDialog && isViewingHistorical" class="historical-info">
          Viser tidligere vernerunde i skrivebeskyttet modus.
        </div>
        <template v-if="!loadingDialog && questions.length">
          <div v-for="(categoryQuestions, categoryName, categorySerialNumber) in groupedQuestions" :key="categoryName" class="mb-4">
            <v-subheader class="category">{{ categoryName }}</v-subheader>
            <v-list>
              <template v-for="q in categoryQuestions" >
                <v-list-tile>
                  <v-list-tile-content v-if="q.positive === 'HLP'">
                    <v-subheader>{{ q.text }}</v-subheader>
                  </v-list-tile-content>

                  <template v-else class="d-flex flex-wrap">
                    <v-list-tile-content>
                      {{q.serial_number}} - {{ q.text }}
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn-toggle :value="selectedResponses[q.id]">
                        <v-btn
                          value="JA"
                          large
                          :disabled="isViewingHistorical"
                          :color="q.positive === 'JA' ? 'green' : 'red'"
                          :depressed="selectedResponses[q.id] !== 'JA'"
                          :outlined="selectedResponses[q.id] !== 'JA'"
                          @click="() => setAnswer(q.id, 'JA')"
                        >JA</v-btn>

                        <v-btn
                          value="NEI"
                          large
                          class="ml-2"
                          :disabled="isViewingHistorical"
                          :color="q.positive === 'NEI' ? 'green' : 'red'"
                          :depressed="selectedResponses[q.id] !== 'NEI'" 
                          :outlined="selectedResponses[q.id] !== 'NEI'"
                          @click="() => setAnswer(q.id, 'NEI')"
                        >NEI</v-btn>
                        <v-btn
                          value="NA"
                          large
                          class="ml-2"
                          :disabled="isViewingHistorical"
                          :color="'yellow'"
                          :depressed="selectedResponses[q.id] !== 'NA'" 
                          :outlined="selectedResponses[q.id] !== 'NA'"
                          @click="() => setAnswer(q.id, 'NA')"
                        >Ikke aktuelt</v-btn>
                      </v-btn-toggle>
                    </v-list-tile-action>
                  </template>
                </v-list-tile>
              </template>
            </v-list>
          </div>
        </template>
        <div v-if="registeredChanges && !isViewingHistorical" style="margin-left:auto;display:flex" class="buttonwrapper">
          <v-btn color="success" @click="saveResponse">Lagre</v-btn>
        </div>
      </div>
      <div ref="pdfContent" class="pdf-export">
        <section class="pdf-page">
          <h1 class="pdf-title">Vernerunde</h1>
          <div class="pdf-meta-row">
            <span>{{ currentVernerundeLabel }}</span>
            <span>{{ pdfModeLabel }}</span>
            <span>{{ pdfSaveDateLabel }}</span>
          </div>
          <div class="pdf-summary-grid">
            <div class="pdf-summary-card">
              <div class="pdf-summary-label">Status</div>
              <div class="pdf-summary-value">{{ pdfModeLabel }}</div>
            </div>
            <div class="pdf-summary-card">
              <div class="pdf-summary-label">Besvarte spørsmål</div>
              <div class="pdf-summary-value">{{ answeredRequiredCount }} / {{ requiredQuestionCount }}</div>
            </div>
            <div class="pdf-summary-card">
              <div class="pdf-summary-label">Avvik</div>
              <div class="pdf-summary-value">{{ sortedNegativeResponses.length }}</div>
            </div>
          </div>
        </section>
        <section v-for="(categoryQuestions, categoryName) in groupedQuestions" :key="`pdf-${categoryName}`" class="pdf-page pdf-page-break">
          <div class="pdf-page-header">
            <div class="pdf-page-kicker">{{ currentVernerundeLabel }}</div>
            <h2 class="pdf-category-title">{{ categoryName }}</h2>
          </div>
          <div class="pdf-question-list">
            <div v-for="question in categoryQuestions" :key="`pdf-question-${question.id}`" class="pdf-question-row">
              <div class="pdf-question-text">
                <strong v-if="question.serial_number">{{ question.serial_number }} - </strong>{{ question.text }}
              </div>
              <div class="pdf-question-answer">{{ getResponseLabel(question) }}</div>
            </div>
          </div>
        </section>
        <section v-for="(chunk, chunkIndex) in negativeResponseChunks" :key="`pdf-risk-${chunkIndex}`" class="pdf-page pdf-page-break">
          <div class="pdf-page-header">
            <div class="pdf-page-kicker">{{ currentVernerundeLabel }}</div>
          <h2 class="pdf-title pdf-title-secondary">Tiltaksvurdering</h2>
          </div>
          <div v-if="!chunk.length" class="pdf-empty-state">
            Ingen registrerte avvik eller tiltak for denne vernerunden.
          </div>
          <table v-else class="pdf-table">
            <thead>
              <tr>
                <th>Kategori</th>
                <th>Spørsmål</th>
                <th>Svar</th>
                <th>Sannsynlighet</th>
                <th>Konsekvens</th>
                <th>Produkt</th>
                <th>Tiltak</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in chunk" :key="`pdf-negative-${chunkIndex}-${item.question_id}`">
                <td>{{ item.serial_number }} - {{ item.category }}</td>
                <td>{{ item.question }}</td>
                <td>{{ formatResponseValue(item.response) }}</td>
                <td>{{ item.likelihood || '-' }}</td>
                <td>{{ item.consequence || '-' }}</td>
                <td>{{ getRiskProduct(item) }}</td>
                <td>{{ item.measure || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </v-tab-item>
    <!-- RISIKOANALYSE -->
    <v-tab-item>
    <v-data-table
      :items="sortedNegativeResponses"
      hide-actions
      group-by="category"
    >
      <template v-slot:headers>
        <th style="width: 15%" align="left">Kategori</th>
        <th style="width: 25%;" align="left">Spørsmål</th>
        <th style="width: 3%;" align="left">Svar</th>
        <th style="width: 10%; white-space: normal;" align="left">
          Sannsynlighet for hendelse
          <v-icon class="ml-3" @click="probabilityDialog = true">help</v-icon>
        </th>
        <th style="width: 10%; white-space: normal;" align="left">
          Alvorlighet ved hendelse
          <v-icon class="ml-3" @click="consequenceDialog = true">help</v-icon>
        </th>
        <th style="width: 1%;" align="left">Produkt</th>
        <th style="width: auto;" align="left">
          Tiltak
          <v-icon class="ml-2" @click="helpDialog = true">help</v-icon>
        </th>
      </template>
      <template v-slot:no-data>
        <td colspan="5" class="pa-0">
          <v-alert
            class="black--text ma-0"
            :value="true"
            color="primary lighten-2"
            icon="info"
            >Ingen aktiviteter registrert enda</v-alert
          >
        </td>
      </template>
      <template v-slot:items="props">
        <tr class="activities">
          <td><strong>{{props.item.serial_number}} - {{ props.item.category }}</strong></td>
          <td>{{ props.item.question }}</td>
          <td>{{ props.item.response }}</td>
          <td>
            <v-select
              :items="probabilityRange"
              v-model="props.item.likelihood"
              :disabled="isViewingHistorical"
              single-line
              class="text-h6"
            ></v-select>
          </td>
          <td>
            <v-select
              :items="consequenceRange"
              v-model="props.item.consequence"
              :disabled="isViewingHistorical"
              single-line
            ></v-select>
          </td>
          <td :class="{'high-risk': props.item.product >= threshhold}">{{ calculateProduct(props.item) }}</td>
          <td>
            <v-text-field
              v-model="props.item.measure"
              :disabled="isViewingHistorical">
              {{ props.item.measure || 'Legg til tiltak' }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.measure"
                  :disabled="isViewingHistorical"
                  label="Beskriv tiltak"
                  single-line
                ></v-text-field>
              </template>
            </v-text-field>
          </td>
        </tr>
      </template>
    </v-data-table>
          <v-btn color="success" :disabled="isViewingHistorical" @click="saveNewActivities">Lagre</v-btn>
    </v-tab-item>
    </v-tabs>
      <v-dialog v-model="helpDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5"><h2>Her skal du sette tiltak som skal inn i handlingsplanen.</h2></span>
          </v-card-title>
          <v-card-text>
            <p>Hva er det dere skal jobbe med ift risikoen som dere har kartlagt?</p>
            <p>Hvis dere har tiltaket klart, så skriver dere inn det.</p>
            <p>Det kan ofte ende med en ROS analyse av problemstillingen. Da skriver dere det.</p>
            <p>Selve ROS analysen gjør dere i ROS modul i Compilo.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="helpDialog = false">
              Lukk
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="probabilityDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5"><h2>Sannsynlighet (Hvor ofte?)</h2></span>
          </v-card-title>
          <v-card-text>
            <p>Skalaen indikerer hvor sannsynlig det er at en hendelse inntreffer:</p>
              
              <p>1 - Svært lite sannsynlig: Skjer nesten aldri (f.eks. mer enn 5 år mellom hver gang).</p>
              <p>2 - Lite sannsynlig: Skjer sjelden (f.eks. 3-5 år).</p>
              <p>3 - Moderat sannsynlig/Mulig: Kan skje (f.eks. 1-3 år).</p>
              <p>4 - Sannsynlig: Skjer ofte (f.eks. innen 1 år).</p>
              <p>5 - Svært sannsynlig/</p> 
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="probabilityDialog = false">
              Lukk
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
            <v-dialog v-model="consequenceDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5"><h2>Konsekvens (Hvor alvorlig?)</h2></span>
          </v-card-title>
          <v-card-text>
            <p>Skalaen indikerer alvorlighetsgraden dersom hendelsen inntreffer (helse, miljø, økonomi):</p>

              <p>1 - Svært liten: Ubetydelig. Ingen skade eller kun bagatellmessig skade/økonomisk tap.</p>
              <p>2 - Liten: Mindre skade/avbrudd. Grunnleggende førstehjelp, mindre økonomisk tap.</p>
              <p>3 - Middels: Merkbar effekt. Skade som krever legebehandling, merkbart økonomisk tap eller driftsstans.</p>
              <p>4 - Stor: Alvorlig. Betydelig skade/ulykke, stort økonomisk tap, brudd på regelverk.</p>
              <p>5 - Svært stor: Katastrofal. Dødsfall, permanent invaliditet, virksomhetskritisk svikt.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="consequenceDialog = false">
              Lukk
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
  <!-- <v-form v-model="questions">
    <template v-slot:items="props">
      <div>{{ props.item.text }}</div>
    </template> 
  </v-form>
   -->
</template>

<script>
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions([
      "GET_VERNERUNDE",
      "SUBMIT_VERNERUNDE_RESPONSE",
      "GET_USER_PLAN",
      "GET_RESPONSES",
      "GET_VERSIONS",
      "GET_RESPONSES_BY_VERSION",
      "GET_VERNERUNDE_ACTIVITIES",
      "GET_VERNERUNDE_ACTIVITIES_BY_VERSION"
    ]),
    formatVernerundeLabel(vernerunde) {
      if (!vernerunde) return "Ukjent vernerunde";

      const label = `Vernerunde ${vernerunde.vernerunde_id}`;
      if (!vernerunde.saved_date) return label;

      const parsedDate = new Date(vernerunde.saved_date);
      if (Number.isNaN(parsedDate.getTime())) return label;

      return `${label} - ${parsedDate.toLocaleDateString("nb-NO")}`;
    },
    formatResponseValue(value) {
      if (value === "NA") return "Ikke Aktuelt";
      if (!value) return "Ikke besvart";

      return value;
    },
    applyResponseData(responseList) {
      this.responses = Array.isArray(responseList) ? responseList : [];
      this.syncLoadedResponses();
    },
    applyActivityData(activityList) {
      if (!Array.isArray(activityList) || !Array.isArray(this.negativeResponses)) {
        return;
      }

      const activityByQuestionId = new Map(
        activityList
          .filter((row) => row && row.question_id != null)
          .map((row) => [Number(row.question_id), row])
      );

      this.negativeResponses = this.negativeResponses.map((item) => {
        const saved = activityByQuestionId.get(Number(item.question_id));
        if (!saved) return item;

        return {
          ...item,
          likelihood: Number(saved.likelihood) || 0,
          consequence: Number(saved.consequence) || 0,
          product: Number(saved.product) || 0,
          measure: saved.measure || ""
        };
      });
    },
    async loadActivities(vernerundeId) {
      try {
        let activityResponse;
        if (vernerundeId) {
          activityResponse = await this.GET_VERNERUNDE_ACTIVITIES_BY_VERSION({
            guid: this.$route.params.guid,
            vernerundeId,
          });
        } else {
          activityResponse = await this.GET_VERNERUNDE_ACTIVITIES(this.$route.params.guid);
        }

        const activityList = Array.isArray(activityResponse.data)
          ? activityResponse.data
          : [];
        this.applyActivityData(activityList);
      } catch (e) {
        // Keep the risk table functional even if activity history is missing.
        console.error(e);
      }
    },
    getResponseLabel(question) {
      if (!question) return "-";
      if (question.positive === "HLP") return "Hjelpetekst";

      return this.formatResponseValue(this.selectedResponses[question.id]);
    },
    syncLoadedResponses() {
      if (!Array.isArray(this.questions) || !Array.isArray(this.responses)) return;

      const questionById = new Map(this.questions.map(q => [q.id, q]));
      const selected = {};
      const negatives = [];

      for (const r of this.responses) {
        if (!r || r.question_id == null) continue;

        selected[r.question_id] = r.response;

        const q = questionById.get(r.question_id);
        if (!q || q.positive === 'HLP') continue;

        if (r.response !== q.positive && r.response !== 'NA') {
          negatives.push({
            question_id: q.id,
            category: q.category,
            actualCategory: q.actual_category,
            question: q.text,
            response: r.response,
            serial_number: q.serial_number,
            likelihood: 0,
            consequence: 0,
            product: 0,
            measure: ""
          });
        }
      }

      this.selectedResponses = selected;
      this.negativeResponses = negatives;
    },
    setAnswer(questionId, value) {
      if (this.isViewingHistorical) return;

      const existingIndex = this.responses.findIndex(r => r.question_id === questionId);
      const hasExisting = existingIndex !== -1;
      const isSameValue = hasExisting && this.responses[existingIndex].response === value;

      // Toggle off if user clicks the same answer again
      if (isSameValue) {
        this.responses.splice(existingIndex, 1);
        this.$delete(this.selectedResponses, questionId);
      } else {
        if (hasExisting) {
          this.responses[existingIndex].response = value;
        } else {
          this.responses.push({ question_id: questionId, response: value });
        }
        this.$set(this.selectedResponses, questionId, value);
      }
      this.registeredChanges = true;

      const currentQuestion = this.questions.find(q => q.id === questionId);
      if (!currentQuestion || currentQuestion.positive === "HLP") return;

      // Remove any existing negative entry for this question
      this.negativeResponses = this.negativeResponses.filter(n => n.question_id !== questionId);

      const selectedValue = this.selectedResponses[questionId];
      if (selectedValue && selectedValue !== currentQuestion.positive && selectedValue !== "NA") {
        this.negativeResponses.push({
          question_id: currentQuestion.id,
          category: currentQuestion.category,
          actualCategory: currentQuestion.actual_category,
          question: currentQuestion.text,
          response: selectedValue,
          serial_number: currentQuestion.serial_number,
          likelihood: 0,
          consequence: 0,
          product: 0,
          measure: ""
        });
      }
    },
    async saveResponse() {
      let ResponseData = {
        Transfer: "saveresponse",
        data: {
          ...this.responses,
          vernerunde_id: this.currentVernerunde
          },
        guid: this.$route.params.guid
        };
      await this.SUBMIT_VERNERUNDE_RESPONSE( ResponseData ).then((res) => {
        this.registeredChanges = false;
      });

      this.activeTab = 2;
    },
    async generatePDF() {
      if (!this.canGeneratePdf || !this.$refs.pdfContent) return;

      this.loadingDialog = true;
      this.loadingDialogText = "Vennligst vent mens PDF genereres";

      try {
        await this.$nextTick();
        const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 10;

        const pages = Array.from(this.$refs.pdfContent.querySelectorAll(".pdf-page"));
        for (let index = 0; index < pages.length; index += 1) {
          const canvas = await html2canvas(pages[index], {
            scale: 2,
            backgroundColor: "#ffffff",
            useCORS: true,
          });
          const imgData = canvas.toDataURL("image/png");
          const imgWidth = pageWidth - margin * 2;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          const fittedHeight = Math.min(imgHeight, pageHeight - margin * 2);

          if (index > 0) {
            pdf.addPage();
          }

          pdf.addImage(imgData, "PNG", margin, margin, imgWidth, fittedHeight);
          pdf.setFontSize(10);
          pdf.text(`${index + 1} / ${pages.length}`, pageWidth - 18, pageHeight - 6);
        }

        pdf.save(`vernerunde_${this.currentVernerunde || 1}.pdf`);
      } finally {
        this.loadingDialog = false;
        this.loadingDialogText = "";
      }
    },
    async loadHistoricalResponses(vernerunde) {
      if (!vernerunde || !vernerunde.vernerunde_id) {
        return;
      }
      this.loadingDialogText = "Vennligst vent mens vi henter tidligere vernerunde";
      this.loadingDialog = true;
      try {
        const res = await this.GET_RESPONSES_BY_VERSION({
          guid: this.$route.params.guid,
          vernerundeId: vernerunde.vernerunde_id,
        });
        this.currentVernerunde = vernerunde.vernerunde_id;
        this.isViewingHistorical = true;
        this.registeredChanges = false;
        this.applyResponseData(res.data);
        await this.loadActivities(vernerunde.vernerunde_id);
      } finally {
        this.loadingDialog = false;
      }
    },
    async loadCurrentResponses() {
      this.isViewingHistorical = false;
      this.registeredChanges = false;
      await this.getResponses();
    },

    async saveNewActivities() {
      if (this.isViewingHistorical) return;

      const responsesThatNeedMeasures = this.negativeResponses.filter((item) => {
        return item.product >= this.threshhold || (item.measure && item.measure.trim() !== '');
      })
      let ResponseData = {
        Transfer: "insertactivities",
        data: {
          ...responsesThatNeedMeasures,
          planningid: this.$route.params.guid,

          vernerunde_id: this.currentVernerunde
          },
        };
      await this.SUBMIT_VERNERUNDE_RESPONSE(ResponseData)
      .then((res) => {
        this.registeredChanges = false;
      })
 
      // Route to planresponse
      this.$router.push({ name: "planresponse", query: { tab: 'planlegge' }})
    },

    calculateProduct(item) {
      item.product = item.likelihood * item.consequence;
      return item.product
    },
    getRiskProduct(item) {
      if (!item || !item.likelihood || !item.consequence) return "-";

      return item.likelihood * item.consequence;
    },
    getQuestions() {
      this.loadingDialogText = "Vennligst vent mens vi henter data";
      this.loadingDialog = true;
      this.GET_VERNERUNDE(this.$route.params.guid)
        .then((res) => {
          this.loadingDialog = false;
          const qs = res && res.data && res.data.questions;
          const questionList = Array.isArray(qs) ? qs : [];
          this.questions = questionList.sort((a,b) => {return a.serial_number - b.serial_number})
            this.syncLoadedResponses();

      })
        .catch((e) => {
          this.loadingDialog = false;
          console.error(e);
        });
    },
    getResponses() {
      this.loadingDialogText = "Vennligs vent mens vi henter data";
      this.loadingDialog = true;
      return this.GET_RESPONSES(this.$route.params.guid /* Organisation ID*/)
        .then((res) => {
          this.loadingDialog = false;
          if(res.data && res.data.length != 0) {
            this.latestVernerunde = (res.data[0].vernerunde_id);
            if(this.latestVernerunde == 0) {
              this.latestVernerunde = 1;
            }
          } else {
            this.latestVernerunde = 1;
          }
          this.currentVernerunde = this.latestVernerunde;
          this.isViewingHistorical = false;
          const resp = res; //Hent responsene fra Datbasen
          const responseList = Array.isArray(resp.data) ? resp.data : []; // Lag ett array av responsene som hentes ned
          /*
          id, org_id, question_id, response, date, planningid, vernerunde_id
          */
           this.applyResponseData(responseList)
           return this.loadActivities(this.currentVernerunde)
        })
    },
    getVersions() {
      this.GET_VERSIONS(this.$route.params.guid)
        .then((res)=> {
          if(res.data && res.data.length != 0) {
            this.vernerunder = res.data
          }
        })
    },
    newVernerunde() {
      if (this.isViewingHistorical) return;

      this.currentVernerunde += 1;
      this.latestVernerunde = this.currentVernerunde;
      this.selectedResponses = {}
      this.responses = []
      this.negativeResponses = []
      this.registeredChanges = false;
    }
  },
  data() {
    return {
      activeTab: 1,
      loadingDialog: false,
      loadingDialogText: "",
      registeredChanges: false,
      questions: [],
      responses: [], // key: question id (or index), value: JA/NEI
      currentVernerunde: 0,
      latestVernerunde: 0,
      isViewingHistorical: false,
      negativeResponses: [],
      vernerunder: [],
      currentPlan: {},
      probabilityRange: [
        {value: 1, text:  "1 - Svært lite sannsynlig"},
        {value: 2, text:  "2 - Lite sannsynlig"},
        {value: 3, text:  "3 - Moderat sannsynlig"},
        {value: 4, text:  "4 - Sannsynlig"},
        {value: 5, text:  "5 - Svært sannsynlig"}
      ],
      consequenceRange: [
        {value: 1, text:  "1 - Svært liten"},
        {value: 2, text:  "2 - Liten"},
        {value: 3, text:  "3 - Middels"},
        {value: 4, text:  "4 - Stor"},
        {value: 5, text:  "5 - Svært stor"}
      ],
      threshhold: 9,
      helpDialog: false,
      probabilityDialog: false,
      consequenceDialog: false,
      selectedResponses: {},
    };
  },
  computed: {
    ...mapGetters(["GET_PLANSFORTHISCUSTOMER", "GET_USER"]),
    // getCurrentPlan() {
    //   this.currentPlan = GET_PLANSFORTHISCUSTOMER()
    //   console.log('current plan: ', this.currentPlan)
    // },
    sortedNegativeResponses() {
      const listCopy = this.negativeResponses;
      return listCopy.sort((a,b) => { return a.serial_number - b.serial_number })
    },

    //store how many actual questions are present (excluding helper texts)
    requiredQuestionIds() {
      return new Set(
        this.questions
          .filter(question => question.positive !== "HLP")
          .map(question => question.id)
      )
    },

    //how many questions that has been answered
    answeredRequiredCount() {
      return new Set(
        this.responses
          .filter(response => this.requiredQuestionIds.has(response.question_id))
          .map(response => response.question_id)
      ).size;
    },

    requiredQuestionCount() {
      return this.requiredQuestionIds.size;
    },

    isComplete() {
      return this.answeredRequiredCount === this.requiredQuestionCount;
    },

    canStartNewVernerunde() {
      return this.isComplete && !this.registeredChanges && !this.isViewingHistorical;
    },
    canGeneratePdf() {
      return !!this.questions.length && !this.loadingDialog && (this.isViewingHistorical || this.isComplete);
    },
    currentVernerundeMetadata() {
      return this.vernerunder.find((vernerunde) => {
        return Number(vernerunde.vernerunde_id) === Number(this.currentVernerunde);
      }) || null;
    },
    currentVernerundeLabel() {
      if (this.currentVernerundeMetadata) {
        return this.formatVernerundeLabel(this.currentVernerundeMetadata);
      }

      return `Vernerunde ${this.currentVernerunde || 1}`;
    },
    pdfModeLabel() {
      if (this.isViewingHistorical) return "Historisk versjon";
      if (this.registeredChanges) return "Pågående, ikke lagret";
      return "Nåværende versjon";
    },
    pdfSaveDateLabel() {
      if (this.currentVernerundeMetadata && this.currentVernerundeMetadata.saved_date) {
        return `Sist lagret: ${new Date(this.currentVernerundeMetadata.saved_date).toLocaleDateString("nb-NO")}`;
      }

      return "Ikke lagret ennå";
    },

    previousVernerunder() {
      return this.vernerunder.filter((vernerunde) => {
        return Number(vernerunde.vernerunde_id) !== Number(this.latestVernerunde);
      });
    },
    negativeResponseChunks() {
      if (!this.sortedNegativeResponses.length) {
        return [[]];
      }

      const chunks = [];
      for (let index = 0; index < this.sortedNegativeResponses.length; index += 12) {
        chunks.push(this.sortedNegativeResponses.slice(index, index + 12));
      }

      return chunks;
    },

    groupedQuestions() {
      const groups = {};
      if (!this.questions || !Array.isArray(this.questions)) {
        return groups;
      }

      for (const question of this.questions) {
        const category = question.category || 'Uncategorized';
        const serialNumber = question.serial_number
        if (!groups[category]) {
          groups[category] = [];
        }
        groups[category].push(question);
      }
      return groups;
    },

  },
  mounted() {
    this.getQuestions();
    this.getResponses(); 
    this.getVersions();
  },
};
</script>

<style>
  a {
    text-decoration: none;
    color: inherit !important
  }
  .form-wrapper {
    max-width: 70%;
    margin: 0;
  }
  .vernerunde-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .historical-info {
    margin-bottom: 16px;
    color: #4f4f4f;
    font-style: italic;
  }
  .pdf-export {
    position: absolute;
    left: -10000px;
    top: 0;
    width: 1000px;
    padding: 32px;
    background: #ffffff;
    color: #111111;
  }
  .pdf-page {
    width: 100%;
    min-height: 1400px;
    padding: 32px 40px;
    box-sizing: border-box;
    background: #ffffff;
  }
  .pdf-page-break {
    break-before: page;
  }
  .pdf-title {
    margin-bottom: 16px;
    font-size: 28px;
  }
  .pdf-title-secondary {
    margin-top: 0;
  }
  .pdf-page-header {
    margin-bottom: 18px;
  }
  .pdf-page-kicker {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #666666;
  }
  .pdf-meta-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
    font-size: 14px;
  }
  .pdf-summary-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-top: 24px;
  }
  .pdf-summary-card {
    padding: 18px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
  }
  .pdf-summary-label {
    margin-bottom: 8px;
    font-size: 12px;
    text-transform: uppercase;
    color: #666666;
  }
  .pdf-summary-value {
    font-size: 22px;
    font-weight: 700;
  }
  .pdf-category-block {
    margin-bottom: 24px;
  }
  .pdf-category-title {
    margin-bottom: 12px;
    font-size: 20px;
  }
  .pdf-question-list {
    border-top: 1px solid #d9d9d9;
  }
  .pdf-question-row {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    padding: 10px 0;
    border-bottom: 1px solid #d9d9d9;
  }
  .pdf-question-text {
    flex: 1;
  }
  .pdf-question-answer {
    width: 160px;
    text-align: right;
    font-weight: 600;
  }
  .pdf-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }
  .pdf-table th,
  .pdf-table td {
    padding: 8px;
    border: 1px solid #d9d9d9;
    vertical-align: top;
    text-align: left;
  }
  .pdf-empty-state {
    font-style: italic;
    color: #4f4f4f;
  }
  .wrap-text {
    white-space: normal;
    word-wrap: break-word;
  }
  .category {
    font-size: 1.5rem;
    font-weight: 500;
    color: rgb(54, 53, 53) !important;
  }
  .buttonwrapper {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 999;
  }
  .activities:nth-child(odd) {
    background-color: #cccccc;
  }
  .high-risk {
    background-color: #fa273c;
  }
  .v-select__selections {
    font-size: 12px !important; /* Adjust the size as needed */
  }
</style>